// extracted by mini-css-extract-plugin
export default {"root":"userBanPopup_root__js97y","title":"userBanPopup_title__evKcr","btn":"userBanPopup_btn__lSJJY"};